import dialog from '../../versa/dialog.js';
import front from '../version.js';
import api from '../api.js';
import changelog from '../changelog.js';

/** Dias de histórico exibidos no Sobre. */
const CHANGELOG_DAYS = 60;

/**
 * Converte dd/mm/aaaa em data local. Devolve null se o texto não for essa data.
 * @param {string} value
 * @returns {Date|null}
 */
const parseDate = (value) =>
{
	const match = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(value || '');
	if (!match)
		return null;
	return new Date(Number(match[3]), Number(match[2]) - 1, Number(match[1]));
};

/**
 * Escapa texto para HTML.
 * @param {unknown} value
 * @returns {string}
 */
const esc = (value) => String(value ?? '')
	.replace(/&/g, '&amp;')
	.replace(/</g, '&lt;')
	.replace(/>/g, '&gt;');

/**
 * Escapa e transforma **negrito** em strong.
 * @param {unknown} value
 * @returns {string}
 */
const rich = (value) => esc(value).replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');

/**
 * Histórico dos últimos 60 dias. Seção vazia não aparece.
 * @param {Array<{ date: string, changes?: string[], add?: string[], bugfix?: string[] }>} entries
 * @returns {string}
 */
const formatChangelog = (entries) =>
{
	const limit = new Date();
	limit.setHours(0, 0, 0, 0);
	limit.setDate(limit.getDate() - CHANGELOG_DAYS);
	const sections = [
		['changes', 'Alterações'],
		['add', 'Novidades'],
		['bugfix', 'Correções'],
	];
	return entries
		.filter((entry) =>
		{
			const date = parseDate(entry.date);
			return date && date >= limit;
		})
		.map((entry) =>
		{
			const blocks = sections
				.filter(([key]) => Array.isArray(entry[key]) && entry[key].length)
				.map(([key, title]) => `<h4>${title}</h4><ul>${entry[key].map((line) => `<li>${rich(line)}</li>`).join('')}</ul>`)
				.join('');
			if (!blocks)
				return '';
			return `<section class="about-day"><h3>${esc(entry.date)}</h3>${blocks}</section>`;
		})
		.join('');
};

const about = async function()
{
	const back = await api.call(api.version);
	const logHtml = formatChangelog(changelog);

	const html = `
		<style>
			#about .about-logos { display: flex; align-items: center; justify-content: center; gap: var(--space-lg); flex-wrap: wrap; }
			#about img.logo-sial { width: 200px; }
			#about img.logo-machadotec { width: 180px; height: auto; }
			#about .about-versions { margin-top: var(--space-md); margin-bottom: var(--space-md); }
			#about .about-legal {
				margin: 0 0 var(--space-md) 0;
				font-size: 0.78rem;
				line-height: 1.4;
				color: #6b7280;
			}
			#about .about-changelog {
				margin-top: var(--space-md);
				margin-bottom: var(--space-md);
				max-height: 32rem;
				overflow-y: auto;
				padding: var(--space-sm) var(--space-md);
				background: var(--bg-secondary, #f8f9fa);
				border: 1px solid var(--border-color, #dee2e6);
				border-radius: 6px;
				font-family: system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif;
				font-size: 0.88rem;
				line-height: 1.45;
				text-align: left;
			}
			#about .about-day { margin: 0 0 1rem 0; padding-bottom: 0.75rem; border-bottom: 1px solid #e5e7eb; }
			#about .about-day:last-child { margin-bottom: 0; padding-bottom: 0; border-bottom: 0; }
			#about .about-day h3 { margin: 0 0 0.35rem 0; font-size: 0.95rem; }
			#about .about-day h4 { margin: 0.55rem 0 0.15rem 0; font-size: 0.72rem; font-weight: 700; letter-spacing: 0.04em; text-transform: uppercase; color: #4b5563; }
			#about .about-day ul { margin: 0; padding-left: 1.1rem; }
			#about .about-day li { margin: 0.15rem 0; }
		</style>
		<div id="about" class="msgbox">
			<div class="about-logos">
				<img src="img/logo_v.png" class="logo-sial" alt="SIAL">
				<img src="img/logo_machadotec.png" class="logo-machadotec" alt="MachadoTec">
			</div>
			<div class="about-versions">
				Frontend: ${esc(front)}<br/>
				Backend: ${esc(back)}<br/>
				Desenvolvido para LLT Consultoria<br/>
				MachadoTec Software Solutions
			</div>
			<p class="about-legal">© LLT Assessoria e Tecnologia Empresarial Ltda. SIAL — software registrado. Todos os direitos reservados.</p>
			<div class="about-changelog">${logHtml || '<p>Nenhuma alteração nos últimos 60 dias.</p>'}</div>
			<button class="bn_Enter button">Fechar</button>
		</div>`;

	let dlg = dialog.create(html, () => dlg.destroy(), /Enter|Escape/);
};

export default about;
